<div class="wrapper-content" [style]="'background-color :'+ item.background">
  @if (item.image) {
    <div class="image main-image">
      @if (item.url) {
        <a [routerLink]="[item.url]" (click)="handleClick(item)">
          <cx-media [container]="item.image"></cx-media>
        </a>
      } @else {
        <cx-media [container]="item.image"></cx-media>
      }
    </div>
  }
  <div class="wrapper-products">
    @if (products$ | async; as products) {
      @for (product of products; track product; let i = $index) {
        @if ( product | async; as prod) {
          <div [class]="'product-'+i">
            <app-custom-product-item [item]="prod"></app-custom-product-item>
          </div>
        }
      }
    }
  </div>
</div>
